import { usePageTitleTranslation } from 'libs/navigation';

import { useAccountingSystem } from '../hooks/useAccountingSystem';
import { AccountingSystemView } from '../views/AccountingSystemView';

export const AccountingSystemContainer = () => {
  const { initialValues, submitLoading, onSubmit } = useAccountingSystem();

  usePageTitleTranslation('administration.title');

  return (
    <AccountingSystemView
      initialValues={initialValues}
      submitLoading={submitLoading}
      onSubmit={onSubmit}
    />
  );
};
